<template>
  <v-dialog
    v-model="dialog"
    persistent
    min-height="500"
    max-width="400">
    <v-card>
      <v-card-title>
        <v-flex class="font-number-2 text-xs-center">Buffering</v-flex>
      </v-card-title>
      <v-layout row wrap align-center>
        <v-flex xs4 />
        <v-flex xs4 text-xs-center>
          <v-progress-circular
            indeterminate
            :size="75"
            :width="5"
            color="primary" />
        </v-flex>
        <v-flex xs4 />
        <v-flex xs4 />
        <v-flex xs4>
          <v-btn @click="$router.push('Likes')">Cancel</v-btn>
        </v-flex>
        <v-flex xs4 />
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/player/BufferDialog.vue